function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/icons/ic_badge_down_2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#ffcc00",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("path", {
  d: "M18.0369594,5 L18.149513,5.00662551 C18.5924713,5.05935292 18.9439154,5.41946106 18.9953306,5.87331393 L19.0018132,5.98860653 L19.0014293,19.4203426 L21.3898027,16.9729273 C21.5572737,16.8013385 21.8172365,16.7822731 22.0052613,16.9157311 L22.0720773,16.9729273 L22.754352,17.6719777 C22.9192063,17.8408855 22.9398131,18.1016208 22.8161723,18.2934855 L22.754352,18.3710281 L18.3776883,22.855207 L18.3108682,22.9124411 C18.203213,22.9888418 18.0719812,23.0152443 17.9480343,22.991648 C17.8243821,23.0153863 17.6927328,22.9890478 17.5847874,22.9124411 L17.5179674,22.855207 L13.1413037,18.3710281 C12.9528988,18.1779907 12.9528988,17.8650151 13.1413037,17.6719777 L13.8235783,16.9729273 C14.0119833,16.7798899 14.3174481,16.7798899 14.505853,16.9729273 L16.8942264,19.4203426 L16.8938425,5.98860653 C16.8938018,5.48161367 17.2662712,5.06374687 17.7461426,5.00662551 L17.8586963,5 L17.9478278,5.005 L18.0369594,5 Z M30.1369594,5 L30.249513,5.00662551 C30.6924713,5.05935292 31.0439154,5.41946106 31.0953306,5.87331393 L31.1018132,5.98860653 L31.1014293,19.4203426 L33.4898027,16.9729273 C33.6572737,16.8013385 33.9172365,16.7822731 34.1052613,16.9157311 L34.1720773,16.9729273 L34.854352,17.6719777 C35.0192063,17.8408855 35.0398131,18.1016208 34.9161723,18.2934855 L34.854352,18.3710281 L30.4776883,22.855207 L30.4108682,22.9124411 C30.303213,22.9888418 30.1719812,23.0152443 30.0480343,22.991648 C29.9243821,23.0153863 29.7927328,22.9890478 29.6847874,22.9124411 L29.6179674,22.855207 L25.2413037,18.3710281 C25.0528988,18.1779907 25.0528988,17.8650151 25.2413037,17.6719777 L25.9235783,16.9729273 C26.1119833,16.7798899 26.4174481,16.7798899 26.605853,16.9729273 L28.9942264,19.4203426 L28.9938425,5.98860653 C28.9938018,5.48161367 29.3662712,5.06374687 29.8461426,5.00662551 L29.9586963,5 L30.0478278,5.005 L30.1369594,5 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}));

const SvgIcBadgeDown2 = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIcBadgeDown2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_badge_down_2.79bec432.svg";
export { ForwardRef as ReactComponent };